import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import LogoImage from "../../images/logo/logo-kz.svg";
import TelegramIcon from "../../images/icon/telegram.svg";
import {SectionFooter, SectionHeading, SectionSteps} from "../misc/Headings";
import WhatsappIcon from "../../images/icon/whatsapp.svg";
import ClassmatesIcon from "../../images/icon/Tik-Tok.svg";
import InstagramIcon from "../../images/logo/Instagram_logo_2022.svg";
import { FiClock } from 'react-icons/fi';
import { FiPhone, FiMail } from 'react-icons/fi';
import { useTranslation } from "react-i18next";

const Container = styled.div`
    ${tw`relative mt-12 -mx-8 -mb-8 px-8 p-10`}
    background-color: #e2ffe2 !important; // Ensure it takes precedence

`;

const Content = tw.div`max-w-screen-xl mx-auto pt-16 pb-8`;
const FiveColumns = styled.div`
    ${tw`grid gap-8`} /* было gap-10 */
        /* узкая 1-я колонка (логотип/контакты) + три равные */
    grid-template-columns: 260px repeat(3, minmax(0, 1fr));

    @media (max-width: 1024px) { /* lg */
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    @media (max-width: 640px) {  /* sm */
        grid-template-columns: 1fr;
    }
`;


const Column = styled.div`
    ${tw`col-span-1 text-sm sm:text-base flex flex-col items-start`}
`;
const CompanyColumn = styled.div`
    ${tw`col-span-1 flex flex-col items-center lg:items-start`}
`;


const CompanyAddress = styled.div`
  ${tw`mt-4 text-base leading-loose text-center lg:text-left`}
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const ColumnHeading = styled.h5`
    ${tw`font-bold text-lg uppercase mb-4 text-left`}
`;

const LinkList = styled.ul`
    ${tw`text-base list-none text-left`}
`;

const LinkListItem = tw.li`mt-3`;
const Link = styled.a`
    ${tw`hover:text-green-500 text-secondary-500 text-lg text-base cursor-pointer`};
    text-decoration: none; // Ensures no underline at all

    &:hover {
        text-decoration: none; // Prevents any text-decoration on hover as well
    }
`;

const LogoImg = styled.img`
// Базовый размер для логотипа
  width: 60%; // Полная ширина
  height: 80%; // Сохраняем пропорции изображения

  @media (max-width: 768px) {
    width: 80%; // Уменьшаем размер логотипа на мобильных устройствах
    margin: 0 auto; // Центрируем логотип
  }

  @media (max-width: 480px) {
    width: 60%; // Ещё больше уменьшаем на маленьких устройствах
  }
`;

const LogoContainer = styled.div`
  ${tw`flex flex-col items-center lg:items-start`}
`;



const SocialLinksContainer = styled.div`
    ${tw`mt-4 flex flex-nowrap items-center justify-center lg:justify-start gap-3`}

    img {
        width: 32px;
        height: 32px;
        object-fit: contain;
        filter: none;
        transition: transform 0.3s ease;

        &:hover {
            transform: scale(1.1);
        }
    }
`;



const SocialLink = styled.a`
    ${tw`cursor-pointer inline-block p-2 text-gray-900 transition duration-300`}
    svg {
        ${tw`w-4 h-4`}
    }
    font-size: 20px;
    line-height: 30px;
    color: #2D2D2D;
    filter: none; // ← убираем grayscale
`;





const Divider = styled.div`
    ${tw`mt-8 border-t border-gray-300`}
`;

const CopyrightNotice = styled.div`
    ${tw`text-center py-4 text-gray-600 text-sm`}
    background-color: #ffffff;
`;


const Text=styled.span`
    ${tw`text-lg text-base`}
`

export default () => {
    const { t } = useTranslation();
    return (
        <>
        <Container>
            <Content>
                <FiveColumns>
                    <CompanyColumn>
                        <LogoContainer>
                            <LogoImg src={LogoImage} style={{width:"100%"}} />
                        </LogoContainer>
                        <SocialLinksContainer>
                            <SocialLink href="https://web.telegram.org/a/">
                                <img src={TelegramIcon} />
                            </SocialLink>

                            <SocialLink href="https://web.whatsapp.com">
                                <img src={WhatsappIcon} />
                            </SocialLink>
                            <SocialLink href="https://www.tiktok.com/">
                                <img src={ClassmatesIcon} />
                            </SocialLink>
                            <SocialLink>
                                <img src={InstagramIcon}/>
                            </SocialLink>

                        </SocialLinksContainer>
                        <CompanyAddress>
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                                <FiPhone style={{ color: "#0ABD19", marginRight: "8px", width: "25px", height: "25px" }} />
                                <Text>+7 700 131 0757</Text>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                                <FiMail style={{ color: "#0ABD19", marginRight: "8px", width: "25px", height: "25px" }} />
                                <Text>info@eparcel.kz</Text>
                            </div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <FiClock style={{ color: "#0ABD19", marginRight: "8px", width: "25px", height: "25px" }} />
                                <Text>Пн. - Пт.: 9:00 - 17:00</Text>
                            </div>
                        </CompanyAddress>
                    </CompanyColumn>

                    <Column>
                        <ColumnHeading>{t("footer.generalInfo")}</ColumnHeading>
                        <LinkList>
                            <LinkListItem><Link href="AboutUS">{t("footer.aboutUs")}</Link></LinkListItem>
                            <LinkListItem><Link href="Rates">{t("footer.services")}</Link></LinkListItem>
                            <LinkListItem><Link href="Tariffs">{t("footer.tariffs")}</Link></LinkListItem>
                            <LinkListItem><Link href="Shops">{t("footer.shops")}</Link></LinkListItem>
                            <LinkListItem><Link href="RedemptionOfGoods">{t("footer.redemption")}</Link></LinkListItem>
                            <LinkListItem><Link href="Contacts">{t("footer.contacts")}</Link></LinkListItem>
                        </LinkList>
                    </Column>
                    <Column>
                        <ColumnHeading>{t("footer.clients")}</ColumnHeading>
                        <LinkList>
                            <LinkListItem><Link href="News">{t("footer.news")}</Link></LinkListItem>
                            <LinkListItem><Link href="Questions">{t("footer.faq")}</Link></LinkListItem>
                            <LinkListItem><Link href="ProhibitedProductsPage">{t("footer.prohibited")}</Link></LinkListItem>
                            <LinkListItem><Link href="DeliveryCalculator">{t("footer.deliveryCalc")}</Link></LinkListItem>
                            <LinkListItem><Link href="DutyCalculatorPage">{t("footer.dutyCalc")}</Link></LinkListItem>
                        </LinkList>
                    </Column>
                    <Column style={{marginRight:"32px"}}>
                        <ColumnHeading>{t("footer.useful")}</ColumnHeading>
                        <LinkList>
                            <LinkListItem><Link href="LegalInformation">{t("footer.legal")}</Link></LinkListItem>
                            <LinkListItem><Link href="HowToBuyGoodsAbroadPage">{t("footer.howToBuy")}</Link></LinkListItem>
                            <LinkListItem><Link href="CustomRegulations">{t("footer.customs")}</Link></LinkListItem>
                            <LinkListItem><Link href="ClothesSizes">{t("footer.sizes")}</Link></LinkListItem>
                            <LinkListItem><Link href="ForBussinesPage">{t("footer.business")}</Link></LinkListItem>
                        </LinkList>
                    </Column>

                </FiveColumns>




            </Content>




        </Container>
    <Divider>
        <CopyrightNotice>&copy; 2025 Eparcel. {t("footer.rights")}</CopyrightNotice>

    </Divider>
</>
    );
};
